import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Grid, Button,  Input } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";

function ItemRateChartMaster(props) {
  const [ItemCode, setItemCode] = useState([]);
  const [ItemName, setItemName] = useState('');
  const [ItemDesc, setItemDesc] = useState('');
  const [Rate, setRate] = useState('');
  const [Remark1, setRemark1] = useState('');
  const [UserID, setUserID] = useState('');

  const [units, setUnits] = useState([]);

  const [formMode, setFormMode] = useState('add');
  const [editchartId, setEditchartCode] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [ItemRateChartMasterEntries, setItemRateChartMasterEntries] = useState([]);

  useEffect(() => {
    fetchItemRateChartMaster();
  }, []);

  const fetchItemRateChartMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/ratechart');
      setItemRateChartMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1; 
      setItemCode (nextEntryNo);
      //console.log(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  
    const calculateMaxEntryNo = (entries) => {
        let maxEntryNo = 0;
        for (const entry of entries) {
            if (entry.ItemCode > maxEntryNo) {
                maxEntryNo = entry.ItemCode;
            }
        }
        return maxEntryNo;
    };

  const addItem = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/ratechart', {
        ItemCode: ItemCode,
        ItemName: ItemName,
        ItemDesc: ItemDesc,
        Rate: Rate,
        Remark1: Remark1,
        USERID: props.name,
      });
      fetchItemRateChartMaster();
      setItemCode('');
      setItemName('');
      setItemDesc('');
      setRate('');
      setRemark1('');
      setUserID('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateItem = async (ItemCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/ratechart/${ItemCode}`, {
        ItemCode: ItemCode,
        ItemName: ItemName,
        ItemDesc: ItemDesc,
        Rate: Rate,
        Remark1: Remark1,
        USERID: props.name,
      });
      fetchItemRateChartMaster();
      setItemCode('');
      setItemName('');
      setItemDesc('');
      setRate('');
      setRemark1('');
      setUserID('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteItem = async (ItemCode) => {
    try {
      await axios.delete(`https://www.wingap.net.in/api/ratechart/${ItemCode}`, {
        headers: {
          'username': props.name,
        },
      });
      fetchItemRateChartMaster();
    } catch (error) {
      console.log('Error:', error);                                                             
    }
  };

  const setEditForm = (room) => {
    setFormMode('edit');
    setItemCode(room.ItemCode);
    setItemName(room.ItemName);
    setItemDesc(room.ItemDesc);
    setRate(room.Rate);
    setRemark1(room.Remark1);
    setUserID(room.UserID);
    setShowGrid(false);
  };

  /* const handleSearch = (searchQuery) => {
    const filtered = units.filter((unit) => {
      const UnitId = unit.UnitId.toString().toLowerCase();
      const UnitName = unit.UnitName.toString().toLowerCase();
      const DeptCode = unit.DeptCode.toString().toLowerCase();
      const YearCode = unit.YearCode.toString().toLowerCase();
      const UserID = unit.UserID.toString().toLowerCase();

      return (
        UnitId.includes(searchQuery.toLowerCase()) ||
        UnitName.includes(searchQuery.toLowerCase()) ||
        DeptCode.includes(searchQuery.toLowerCase()) ||
        YearCode.includes(searchQuery.toLowerCase()) ||
        UserID.includes(searchQuery.toLowerCase())
      );
    });

    setchartMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, units]);*/

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setUnits(units);
  };

    const handleCancel = () => {
        setFormMode('add');
        setEditchartCode('');
        setItemCode('');
        setItemName('');
        setItemDesc('');
        setRate('');
        setRemark1('');
        setUserID('');
        fetchItemRateChartMaster();
    };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "chart Data",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }

        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });


  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Item Rate Chart Master</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>
          {formMode === 'add' ? 'Add' : 'Edit'}
        </h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="ItemCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              ItemCode
            </label>
            <input
              type="text"
              value={ItemCode}
              readOnly
              placeholder="ItemCode"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="ItemName" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              ItemName
            </label>
            <input
              type="text"
              value={ItemName}
              onChange={(e) => setItemName(e.target.value)}
              placeholder="ItemName"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>

          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="ItemDesc" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              ItemDesc
            </label>
            <input
              type="text"
              value={ItemDesc}
              onChange={(e) => setItemDesc(e.target.value)}
              placeholder="ItemDesc"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="Rate" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              Rate
            </label>
            <input
              type="text"
              value={Rate}
              onChange={(e) => setRate(e.target.value)}
              placeholder="Rate"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>

          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="Remark1" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              Remark1
            </label>
            <input
              type="text"
              value={Remark1}
              onChange={(e) => setRemark1(e.target.value)}
              placeholder="Remark1"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="UserID" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              UserID
            </label>
            <input
              type="text"
              value={UserID}
              readOnly
              onChange={(e) => setUserID(e.target.value)}
              placeholder="UserID"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addItem : () => updateItem(ItemCode)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
        
      </>      
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ItemCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ItemName 
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Rate 
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {ItemRateChartMasterEntries.map((chart) => (
                <tr key={chart.ItemCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{chart.ItemCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{chart.ItemName}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{chart.Rate}</td>

                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(chart)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => deleteItem(chart.ItemCode)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
export default ItemRateChartMaster;

